import { Box, styled } from '@mui/material';

export const DurationContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(10),
  display: 'flex',
  justifyContent: 'center',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  gap: theme.spacing(0.5),
  '& .separator': {
    marginLeft: theme.spacing(0.3),
    marginRight: theme.spacing(0.3),
  },
  [theme.breakpoints.down('sm')]: {
    display: 'none',
  },
}));
